import t from "@ext/localization/locale/translate";
import getDisplayValue from "@ext/properties/logic/getDisplayValue";
import { type Property, type PropertyID, PropertyTypes, type ViewRenderGroup } from "@ext/properties/models";

const getGroupTitle = (group: ViewRenderGroup, catalogProps: Map<PropertyID, Property>): string => {
	const key = group.group?.[0];
	if (key === null || key === undefined) return t("properties.empty");

	const type = catalogProps.get(group.groupBy)?.type;
	if (!type) return String(key);
	if (type === PropertyTypes.flag) return String(getDisplayValue(type, key, key === "yes"));
	return String(getDisplayValue(type, [key]));
};

export default getGroupTitle;
